module.exports = __webpack_public_path__ + "static/media/why1.79e304e1.png";